import React from "react";

const Warning = () => {
  return (
    <div className="warning-wrapper">
      <div className="logo-holder"></div>
      <div className="warning-desc">
        This iMagazine needs to be viewed in a modern browser.
      </div>
      <div className="warning-desc">
        Please use <a href="https://www.google.com/chrome/">Google Chrome</a>,{" "}
        <a href="https://www.apple.com/safari/">Safari by Apple</a>,{" "}
        <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge</a>,{" "}
        <a href="https://www.mozilla.org/en-US/firefox/new/">Mozilla Firefox</a>{" "}
        or <a href="https://www.opera.com/download">Opera browser</a>.
      </div>
    </div>
  );
};
export default Warning;
